import { render, staticRenderFns } from "./CurrentLoactionHeader.vue?vue&type=template&id=353f423b&scoped=true"
import script from "./CurrentLoactionHeader.vue?vue&type=script&lang=js"
export * from "./CurrentLoactionHeader.vue?vue&type=script&lang=js"
import style0 from "./CurrentLoactionHeader.vue?vue&type=style&index=0&id=353f423b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f423b",
  null
  
)

export default component.exports